//---PROD
//let REACT_APP_API_URL="http://170.239.56.101/apivehiculos"

//---nueva  PROD
let REACT_APP_API_URL="https://secove.inab.gob.gt/apivehiculos"

//---DEV
//let REACT_APP_API_URL="http://localhost:26220"
//let REACT_APP_API_URL= process.env.REACT_APP_API

//---URL PARA SISTEMA DE CAPACITACION
//let REACT_APP_API_URL="https://secovecapa.inab.gob.gt/apivehiculoscapa"

//let REACT_APP_API_URL=process.env.REACT_APP_API
 

export default REACT_APP_API_URL